import { render, staticRenderFns } from "./viewMedicalVisitDetail.vue?vue&type=template&id=604fceda&scoped=true&"
import script from "./viewMedicalVisitDetail.vue?vue&type=script&lang=js&"
export * from "./viewMedicalVisitDetail.vue?vue&type=script&lang=js&"
import style0 from "./viewMedicalVisitDetail.vue?vue&type=style&index=0&id=604fceda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604fceda",
  null
  
)

export default component.exports